import React, {useState} from 'react';
import { styled } from '@mui/material/styles';
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, Label, LabelList } from 'recharts';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import styles from "./barAndLineComboChart.module.css";
import InsightTable from '../table/insightTable';
import SharedMaintenanceTable from '../table/SharedMaintenanceTable';

    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
        '& .MuiToggleButtonGroup-grouped': {
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px 5px",
        textTransform: "none",  
        width: "12rem",
        color: "#2B2B2B",
        '&:hover': {
            background: "transparent",
        }
        },
        '& .MuiToggleButtonGroup-grouped.Mui-selected': {
        background: "#1F36C7",
        color: "white",
        '&:hover': {
            background: "#1F36C7",
            color: "white"
        }
        }
    }));

const BarAndLineComboChartProjectedOr = ({ plannedData, sharedData }) => {
    const [viewType, setViewType] = useState('Planned maintenance');
    const transformedData = plannedData?.map(item => ({
        withPM: item["Available capacity with PM"] || 0,
        withoutPM: item["Available capacity without PM"] || 0,
        label: item["label"] || 'N/A'
    }));

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const handleToggleBtnChange = (event, newViewType) => {
        if (newViewType !== null) {
            setViewType(newViewType);
        }
    };

    const checkForMaintenanceData = (view) => {
        if (view === viewType) {
            if (plannedData[0]?.message) {
                return false;
            } else {
                return true;
            }
        } else if (view === viewType) {
            if (sharedData[0]?.message) {
                return false;
            } else {
                return true;
            }
        } else{
            return false;
        }
    };

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <div style={{ marginBottom: "10px" }}>
                    <StyledToggleButtonGroup
                        color="primary"
                        value={viewType}
                        exclusive
                        onChange={handleToggleBtnChange}
                        aria-label="Platform"
                        size="small"
                    >
                        <ToggleButton value="Planned maintenance">
                            Planned maintenance
                        </ToggleButton>
                        <ToggleButton value="Shared recommendation">
                            Shared recommendation
                        </ToggleButton>
                    </StyledToggleButtonGroup>
                </div>
            </div>
            {/* for planned maintenance */}
            {viewType === 'Planned maintenance' && (
                checkForMaintenanceData('Planned maintenance') ? (
                    <ResponsiveContainer width="100%" height={220}>
                        <ComposedChart data={transformedData}
                            margin={{
                                top: 10,
                                right: 0,
                                bottom: 10,
                                left: 0,
                            }} >
                            <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                            <XAxis dataKey="label" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                                <Label value="Current week planned maintenance (PM)" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} />
                            </XAxis>
                            <YAxis domain={[0, 'auto']} tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                                <Label value="Quantity (tonnes)" angle={-90} offset={15} position="insideLeft" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500', textAnchor: "middle" }} />
                            </YAxis>
                            <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />

                            <Bar
                                radius={[4, 4, 0, 0]}
                                dataKey="withPM"
                                name="Available capacity with PM"
                                fill="#005EEF"
                                barSize={40}
                            >
                                <LabelList
                                    dataKey="withPM"
                                    position="top"
                                    style={{ fill: '#2B2B2B', fontSize: 10, fontWeight: "500" }}
                                />
                            </Bar>
                            <Bar
                                dataKey="withoutPM"
                                name="Available capacity without PM"
                                fill="#00B190"
                                barSize={40}
                                radius={[4, 4, 0, 0]}
                            >
                                <LabelList
                                    dataKey="withoutPM"
                                    position="top"
                                    style={{ fill: '#2B2B2B', fontSize: 10, fontWeight: "500" }}
                                />
                            </Bar>
                        </ComposedChart>
                    </ResponsiveContainer>
                ) : (
                    <InsightTable data={plannedData} />
                ))}
            {/* For Shared Recommendation */}
            {viewType === 'Shared recommendation' &&
                (checkForMaintenanceData('Shared recommendation') ? (
                    <SharedMaintenanceTable data={sharedData} />
                ) : (
                    <InsightTable data={sharedData} />
                ))}
        </>
    );
};

export default BarAndLineComboChartProjectedOr;